<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :ColonneWidth="['25%', '25%', '25%', '25%']" :GetFunction="getSupplierLocationlist">
        <template v-slot:Filter0>
            <ColumnFilter :title="$t('suppliers.locationTab.headers.name')" :Filter="FieldName"
                :getList="getSupplierLocationlist" @cancel="FieldName = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldName" id="FieldName" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter1>
            <ColumnFilter :title="this.$t('suppliers.locationTab.headers.country')" :Filter="FieldCountry"
                :getList="getSupplierLocationlist" @cancel="FieldCountry = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldCountry" id="FieldCountry" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter2>
            <ColumnFilter :title="$t('suppliers.locationTab.headers.city')" :Filter="FieldCity"
                :getList="getSupplierLocationlist" @cancel="FieldCity = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldCity" id="FieldCity" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter3>
            <ColumnFilter :title="$t('suppliers.locationTab.headers.postalCode')" :Filter="FieldPostalCode"
                :getList="getSupplierLocationlist" @cancel="FieldPostalCode = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldPostalCode" id="FieldPostalCode" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:item0="{ item }">{{ item.locationName }}</template>
        <template v-slot:item1="{ item }">{{ item.country }}</template>
        <template v-slot:item2="{ item }">{{ item.city }}</template>
        <template v-slot:item3="{ item }">{{ item.postalCode }}</template>
        <template v-slot:edit="{ item, index }">
            <supplier-location-edit-menu :Id="index" :Supplier="item"
                :getSupplierLocationlist="getSupplierLocationlist" />
        </template>
    </gridComponent>
</template>
<script>
import gridComponent from "@/genericComponent/gridComponent.vue";
import SupplierLocationEditMenu from "./SupplierLocationEditMenu.vue";
import { getSupplierLocationlist, isSupplier, idSupplier } from "@/api/index"
import ColumnFilter from "@/genericComponent/ColumnFilter.vue";
export default {
    name: "SupplierLocationsTab",
    components: { SupplierLocationEditMenu, gridComponent, ColumnFilter },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            idSupplier: null,
            itemsData: {},
            items: [],
            search: null,
            FieldName: null,
            FieldAddress: null,
            FieldCity: null,
            FieldPostalCode: null,
            FieldCountry: null,
            SortedBy: "",
            SortingType: ""
        };
    },
    created() {
        this.idSupplier = isSupplier() ? idSupplier() : this.$route.params.id;
    },
    mounted() {
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
            this.getSupplierLocationlist();
        })
    },
    unmounted() {
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
    },
    methods: {
        getSupplierLocationlist: function (page) {
            if (page) { this.page = page }
            getSupplierLocationlist(this.page, this.PageSize, this.idSupplier, this.FieldName == null ? this.search : this.FieldName,
                this.FieldAddress, this.FieldCity, this.FieldPostalCode, this.FieldCountry, this.SortedBy, this.SortingType).then((response) => {
                    this.items = response.data.items
                    this.itemsData.numberOfPage = response.data.totalPages;
                    this.itemsData.totalItemsCount = response.data.totalCount;
                    this.itemsData.pageNumber = response.data.pageNumber;
                    this.itemsData.hasPreviousPage = response.data.hasPreviousPage
                    this.itemsData.hasNextPage = response.data.hasNextPage
                    this.loader = false;
                })
        }
    },
    computed: {
        headers() {
            return [
                this.$t('suppliers.locationTab.headers.name'),
                this.$t('suppliers.locationTab.headers.country'),
                this.$t('suppliers.locationTab.headers.city'),
                this.$t('suppliers.locationTab.headers.postalCode')
            ]
        },
    }
};
</script>